/* Add to theme.js or a new JS file */
const observer = new IntersectionObserver((entries) => {
  entries.forEach(e => {
    if (e.isIntersecting) {
      e.target.classList.add('is-visible');
      observer.unobserve(e.target);
    }
  });
}, { threshold: 0.15 });

document.querySelectorAll('.animate-fade-up').forEach(el => observer.observe(el));
document.addEventListener('cart:updated', () => {
  const icon = document.querySelector('.header__icon--cart');
  if (!icon) return;
  icon.classList.remove('cart-shake');
  void icon.offsetWidth; // reflow
  icon.classList.add('cart-shake');
});
/* ==============================================
   TRADE THEME — Premium Animations JS Bundle
   Two options to add this file:

   OPTION A (recommended):
   1. Go to Assets > Add a new asset > Create blank file
   2. Name it: trade-animations.js
   3. Paste this entire file
   4. Open Layout > theme.liquid
   5. Add before </body>:
      {{ 'trade-animations.js' | asset_url | script_tag }}

   OPTION B (quick):
   Paste only the JS content (not these comments)
   at the bottom of Assets > theme.js
   =============================================== */

(function () {
  'use strict';

  /* ── 1. FADE UP ON SCROLL ──────────────────────
     Watches any element with class "animate-fade-up"
     and reveals it when it enters the viewport.
     Add class="animate-fade-up" to any element in
     your theme sections to activate.
  ─────────────────────────────────────────────── */
  function initFadeUp() {
    var elements = document.querySelectorAll('.animate-fade-up');
    if (!elements.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ── 6. CART ICON SHAKE ────────────────────────
     Listens for Shopify's native cart update events
     and shakes the cart icon as tactile feedback.
  ─────────────────────────────────────────────── */
  function initCartShake() {
    function shakeCart() {
      var icon = document.querySelector('.header__icon--cart');
      if (!icon) return;
      icon.classList.remove('cart-shake');
      void icon.offsetWidth; // force reflow to restart animation
      icon.classList.add('cart-shake');
      icon.addEventListener('animationend', function () {
        icon.classList.remove('cart-shake');
      }, { once: true });
    }

    // Shopify native cart event
    document.addEventListener('cart:updated', shakeCart);

    // Fallback: watch for fetch requests to cart/add
    var _fetch = window.fetch;
    window.fetch = function () {
      var result = _fetch.apply(this, arguments);
      var url = arguments[0];
      if (typeof url === 'string' && url.includes('/cart/add')) {
        result.then(function (res) {
          if (res.ok) shakeCart();
          return res;
        });
      }
      return result;
    };
  }

  /* ── AUTO FADE-UP: COMMON SECTIONS ────────────
     Automatically applies fade-up to common Trade
     theme elements so you don't have to add the
     class manually to every element.
  ─────────────────────────────────────────────── */
  function autoTagFadeUp() {
    var selectors = [
      '.card--product',
      '.collection-list__item',
      '.featured-collection',
      '.rich-text',
      '.image-with-text',
      '.multicolumn-list__item',
      '.testimonials-slider__slide',
      'section .title',
      'section h2',
      'section .subtitle'
    ];

    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (!el.closest('[class*="hero"]')) { // skip hero — already visible
          el.classList.add('animate-fade-up');
        }
      });
    });
  }

  /* ── INIT ───────────────────────────────────── */
  function init() {
    // Respect reduced motion OS setting
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    autoTagFadeUp();
    initFadeUp();
    initCartShake();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();